import { FunctionComponent } from 'react';
import Groups from '../../Groups/GroupsContainer';

type FC = FunctionComponent;

const BulkPaymentContainer: FC = () => {
  return <Groups type="Payment" />;
};

export default BulkPaymentContainer;
